import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@repo/ui/card'
import { useT } from '@repo/ui/hooks'
import { Plus, Wand2 } from 'lucide-react'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'

import { InsightsList } from '@/components/admin/insights/list/List'
import { InsightWidgetShowDialog } from '@/components/admin/insights/list/ShowDialog'
import { beneficiaryInsightsActions as actions } from '@/store/beneficiary-insights/slice'
import { useStoreDispatch, useStoreState } from '@/store/hooks'

import { buildSearchParam, SearchParamsViewNames } from '..'

export function InsightsListRoute() {
  const { t } = useT({ keyPrefix: 'admin.insights.list' })

  const dispatch = useStoreDispatch()

  const widgets = useStoreState((state) => state.beneficiaryInsights.widgets)
  const loading = useStoreState((state) => state.beneficiaryInsights.loading)

  useEffect(() => {
    void dispatch(actions.reset())
    void dispatch(actions.getAllWidgets())
  }, [])

  return (
    <>
      <Card className="flex flex-1 flex-col overflow-hidden bg-opacity-20">
        <CardHeader>
          <CardTitle>{t('title')}</CardTitle>
          <CardDescription>{t('description')}</CardDescription>
          <CardAction>
            <Link
              to={buildSearchParam('view', SearchParamsViewNames.INSIGHTS_CHAT)}
              className="flex items-center gap-2 hover:bg-primary-100 hover:text-primary-900 dark:hover:bg-primary-800 dark:hover:text-primary-50 relative rounded-sm px-2 py-1.5 text-sm outline-none transition-colors"
            >
              <Wand2 className="size-4" />
              {t('addInsights')}
            </Link>

            <Link
              to={buildSearchParam('view', SearchParamsViewNames.INSIGHTS_NEW)}
              className="flex items-center gap-2 hover:bg-primary-100 hover:text-primary-900 dark:hover:bg-primary-800 dark:hover:text-primary-50 relative rounded-sm px-2 py-1.5 text-sm outline-none transition-colors"
            >
              <Plus className="size-4" />
              {t('addInsightsManually')}
            </Link>
          </CardAction>
        </CardHeader>
        <CardContent className="flex flex-1 flex-col gap-4 h-full overflow-y-auto">
          {!loading && <InsightsList widgets={widgets} />}
        </CardContent>
      </Card>
      <InsightWidgetShowDialog />
    </>
  )
}
